import FormModal from "../../../components/FormModal/FormModal";
import TextInput from "../../../components/TextInput/TextInput";
import Buttons from "../../../components/Buttons/Buttons";
import SelectInput from "../../../components/SelectInput/SelectInput";
import FieldLabel from "../../../components/FieldLabel/FieldLabel";
import JsonFilePicker from "./JsonFilePicker";
import { UDI_STATIC_PREFIX } from "./useAddDevice";

const DEVICE_NAME_PREFIX = "We-Be ";

const AddDeviceFormModal = ({
  open,
  onClose,
  isEditing,
  addForm,
  errors,
  onChange,
  onSubmit,
  healthProfessionalData,
  createMode,
  onCreateModeChange,
  jsonFile,
  jsonFileError,
  onJsonFileSelected,
}) => {
  const isJsonMode = !isEditing && createMode === "json";

  return (
    <FormModal
      open={open}
      onClose={onClose}
      title={isEditing ? "Edit Device" : "Add New Device"}
      actions={
        <>
          <Buttons text="Cancel" variant="secondary" onClick={onClose} />
          <Buttons
            text={isEditing ? "Update" : "Submit"}
            variant="primary"
            onClick={onSubmit}
          />
        </>
      }
    >
      <div className="add-device-form-container">
        {!isEditing && (
          <div className="add-device-mode-toggle">
            <Buttons
              text="Manual Entry"
              type="button"
              variant={createMode === "manual" ? "primary" : "secondary"}
              onClick={() => onCreateModeChange("manual")}
            />
            <Buttons
              text="Upload JSON"
              type="button"
              variant={createMode === "json" ? "primary" : "secondary"}
              onClick={() => onCreateModeChange("json")}
            />
          </div>
        )}

        {isJsonMode ? (
          <div className="add-device-form-field">
            <FieldLabel>Device JSON File</FieldLabel>
            <JsonFilePicker file={jsonFile} onFileSelected={onJsonFileSelected} error={jsonFileError} />
          </div>
        ) : (
          <>
            <div className="add-device-form-field">
              {isEditing ? (
                <div className="add-device-readonly-field">
                  <FieldLabel>Device Name</FieldLabel>
                  <div className="add-device-readonly-value">
                    {addForm.deviceName || "-"}
                  </div>
                </div>
              ) : (
                <>
                  <TextInput
                    title="Device Name*"
                    type="text"
                    name="deviceName"
                    value={addForm.deviceName}
                    onChange={onChange}
                    placeholder="72f9"
                    prefixText={DEVICE_NAME_PREFIX}
                    maxLength={4}
                    error={!!errors.deviceName}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        onSubmit();
                      }
                    }}
                  />
                  {errors.deviceName && <span className="error">{errors.deviceName}</span>}
                </>
              )}
            </div>

            <div className="add-device-form-field add-device-udi-section">
              <div className="add-device-udi-header">
                <FieldLabel>Device UDI</FieldLabel>
                <span className="add-device-udi-prefix">
                  Prefix: <strong>{UDI_STATIC_PREFIX}</strong>
                </span>
              </div>
              <div className="add-device-udi-inputs">
                <TextInput
                  name="udiLotCode"
                  placeholder="e.g., 00A"
                  prefixText="(10)"
                  maxLength={3}
                  value={addForm.udiLotCode}
                  onChange={onChange}
                  error={!!errors.udiLotCode}
                  helperText={errors.udiLotCode}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      onSubmit();
                    }
                  }}
                />
                <TextInput
                  name="udiSerial"
                  placeholder="e.g., 0000000"
                  prefixText="(21)"
                  maxLength={7}
                  value={addForm.udiSerial}
                  onChange={onChange}
                  error={!!errors.udiSerial}
                  helperText={errors.udiSerial}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      onSubmit();
                    }
                  }}
                />
              </div>
            </div>
          </>
        )}

        <div className="add-device-form-field">
          <TextInput
            title={isEditing || isJsonMode ? "Number Of Slots" : "Number Of Slots*"}
            type="text"
            name="numberOfSlots"
            value={addForm.numberOfSlots}
            onChange={onChange}
            placeholder="Number Of Slots"
            error={!!errors.numberOfSlots}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                onSubmit();
              }
            }}
          />
          {errors.numberOfSlots && <span className="error">{errors.numberOfSlots}</span>}
        </div>

        {isEditing && (
          <div className="add-device-form-field">
            <div className="add-device-readonly-field">
              <FieldLabel>Assigned Health Professional</FieldLabel>
              <div className="add-device-readonly-value">
                {addForm.healthProfessionalName || "Not Assigned"}
              </div>
            </div>
          </div>
        )}

        <div className="add-device-form-field">
          <SelectInput
            title={isEditing ? "Reassign / Assign Health Professional" : "Select Health Professional"}
            name="healthProfessionalId"
            placeholder="Select Health Professional"
            value={addForm.healthProfessionalId}
            onChange={onChange}
            options={healthProfessionalData}
            clearable
          />
          {errors.healthProfessionalId && (
            <span className="error">{errors.healthProfessionalId}</span>
          )}
        </div>
      </div>
    </FormModal>
  );
};

export default AddDeviceFormModal;
